// extracted by mini-css-extract-plugin
export default {"modalContent":"BlockpassModal_modalContent__xCTcS","buttonContainer":"BlockpassModal_buttonContainer__ctKUb"};